import React, { useEffect, useMemo, useState } from "react";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import TableContainer from '../../components/Common/DataTableContainer';
import CreateSolution from "./CreateSolution";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { deleteSolution, updateSolution } from "store/actions";

import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const SolutionTable = ({ List, loading,isOpen,setIsOpen }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [editData, setEditData] = useState();
    const [deleteId, setDeleteId] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [confirmAction, setConfirmAction] = useState(false);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));
    const hasEditPermission = permissions?.some(item => item?.permissionName === "Edit Solution");
    const hasDeletePermission = permissions?.some(item => item?.permissionName === "Delete Solution");

    const handleDelete = (solutionId) => {
        dispatch(deleteSolution(solutionId));
        setDeleteId('');
        setOpenModal(false);
        setConfirmAction(false);
    };

    useEffect(() => {
        if (deleteId && confirmAction) {
            handleDelete(deleteId);
        }
    }, [deleteId, confirmAction]);

    const columns = useMemo(() => [
        {
            header: 'Solution Name',
            accessorKey: 'solutionName',
            enableColumnFilter: false,
            enableSorting: true,
        },
        ...(hasEditPermission || hasDeletePermission ? [{
            header: 'Actions',
            id: 'actions',
            cell: ({ row }) => {
                const handleEdit = () => {
                    setEditData(row.original);
                    setIsOpen(true);
                };

                return (
                    <div className="d-flex gap-2">
                        {hasEditPermission && (
                            <Button color="primary" onClick={handleEdit}>
                                <FaRegEdit size={18} />
                            </Button>
                        )}
                        {hasDeletePermission && (
                            <Button color="danger" onClick={() => { setDeleteId(row?.original?.solutionId); setOpenModal(true); }}>
                                <MdDeleteOutline size={18} />
                            </Button>
                        )}
                    </div>
                );
            },
        }] : []),
    ], [hasEditPermission, hasDeletePermission]);

    const handleSubmit = (data,onClose) => {
        dispatch(updateSolution(data,onClose));
    };

    const handleClose = () => setIsOpen(false);

    document.title = "Solutions | Admin Dashboard";

    return (
        <>
            <ConfirmationModal
                okText="Confirm"
                onCancel={() => { setDeleteId(''); setOpenModal(false); }}
                onOk={() => { setConfirmAction(true); }}
                isVisible={openModal}
                title="Delete Solution"
                content="Are you sure you want to delete this solution?"
            />
            <CreateSolution
                visible={isOpen}
                initialData={editData}
                onSubmit={handleSubmit}
                handleClose={handleClose}
            />
            <div className="container-fluid">
                <TableContainer
                    loading={loading}
                    columns={columns}
                    data={List || []}
                    isGlobalFilter={true}
                    isPagination={true}
                    SearchPlaceholder="Search..."
                    pagination="pagination"
                    docName="Solutions"
                    paginationWrapper="dataTables_paginate paging_simple_numbers"
                    tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                />
            </div>
        </>
    );
};

export default SolutionTable;
